<div class="table-responsive" id="tableFormCalc">
  <app-calculator-form></app-calculator-form>
</div>
